// ----- read-more
(function () {
    this.ExpandedContent = function () {
        var defaults = {
            element: false,
            height: '200',
            speed: '0.3s',
            delay: '1000',
            button: $('.js_expand_btn'),
            textExpand: 'Развернуть',
            textCollapse: 'Свернуть'
        };
        this.config = this._extend(defaults, arguments[0]);
        this.init();
    };
    ExpandedContent.prototype.init = function () {

        if (this._checkInit()) {
            return false;
        }
        var $this = this;
        this.elem = this.config.element;
        this.contentOuter = this.elem.find('.js_expanded_outer');
        this.content = this.elem.find('.js_expanded_content');
        // console.log(this.content.height());
        if (this.content.height() > this.config.height) {
            setTimeout(function () {
                $this.contentOuter.css('height', $this.config.height);
            }, $this.config.delay);

        } else {
            // this.contentOuter.height('auto');
        }
        this.contentOuter.css('transition-duration', this.config.speed);
        this.start();
    };
    ExpandedContent.prototype.start = function () {
        if (this.config.button.length) {
            var that = this;
            this.config.button.on('click', function () {
                if (that.contentOuter.hasClass('is-expanded')) {
                    that.collapse();
                } else {
                    that.expand();
                }
            });
            // console.log(this.content.height());
            if (this.content.height() < this.config.height) {
                this.config.button.hide();
            } else {

            }
        }
    };
    ExpandedContent.prototype.expand = function () {
        this.contentOuter.css({
            height: this.content.innerHeight()
        }).addClass('is-expanded');
        if (this.config.button.length) {
            this.config.button.html(this.config.textCollapse);
        }
    };
    ExpandedContent.prototype.collapse = function () {
        this.contentOuter.css({
            height: this.config.height
        }).removeClass('is-expanded');
        if (this.config.button.length) {
            this.config.button.html(this.config.textExpand);
        }
    };
    ExpandedContent.prototype._extend = function (defaults, custom) {
        if (typeof custom === 'object') {
            var key;
            for (key in defaults) {
                if (!custom.hasOwnProperty(key)) {
                    custom[key] = defaults[key];
                }
            }
        } else {
            custom = defaults;
        }
        return custom;
    };
    ExpandedContent.prototype._checkInit = function () {
        if (this.config.element.length) {
            return false;
        }
    };
})();
// ----- read-more end